import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _RegradingModal;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@instructure/ui-alerts';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { Heading } from '@instructure/ui-heading';
import { RadioInput, RadioInputGroup } from '@instructure/ui-radio-input';
import { jsx, InstUISettingsProvider } from '@instructure/emotion';
import { Modal, ModalHeader, ModalBody, ModalFooter, XSMALL_SIDE_MARGIN, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
export var RegradingModal = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_RegradingModal = /*#__PURE__*/function (_Component) {
  function RegradingModal() {
    var _this;
    _classCallCheck(this, RegradingModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RegradingModal, [].concat(args));
    _defineProperty(_this, "state", {
      hasGenericErrorFromApi: false
    });
    // Handlers
    _defineProperty(_this, "clearGenericErrorFromApi", function () {
      _this.setState({
        hasGenericErrorFromApi: false
      });
    });
    _defineProperty(_this, "cancelAction", function () {
      _this.clearGenericErrorFromApi();
      _this.props.closeModal();
    });
    _defineProperty(_this, "onSpeedgraderOptionChange", function (event, newValue) {
      _this.props.setScoreReconciliation(newValue);
    });
    _defineProperty(_this, "onSubmit", function () {
      var _this$props = _this.props,
        createQuizEntryRegrade = _this$props.createQuizEntryRegrade,
        quizId = _this$props.quizId,
        regradingPayload = _this$props.regradingPayload,
        scoreReconciliation = _this$props.scoreReconciliation;
      _this.clearGenericErrorFromApi();
      createQuizEntryRegrade(quizId, _objectSpread(_objectSpread({}, regradingPayload), {}, {
        scoreReconciliation: scoreReconciliation
      })).then(function () {
        _this.props.toggleRegradingEditMode('');
        _this.props.addSuccess(t('Regrade scheduled successfully; check back later to see it applied.'));
      })["catch"](function (e) {
        if (e.validationErrorsFromApi) {
          // Close the modal so the user can view the input validation errors and correct them
          _this.cancelAction();
          _this.props.handleValidationErrorsFromApi(e.validationErrorsFromApi);
        } else {
          // Some other type of error occurred
          _this.setState({
            hasGenericErrorFromApi: true
          });
        }
        throw e;
      });
    });
    return _this;
  }
  _inherits(RegradingModal, _Component);
  return _createClass(RegradingModal, [{
    key: "optionInputs",
    get:
    // Getters
    function get() {
      return {
        new_score: {
          hint: t('some scores may be reduced, some may be raised'),
          text: t('award points for correct answer only')
        },
        old_score: {
          hint: t('no scores will be reduced'),
          text: t('award points for both current and previous answers')
        },
        any_response: {
          hint: t('everyone who answers gets full credit'),
          text: t('award points for any submitted answer')
        },
        thrown_out: {
          hint: t('full credit awarded to all who have submitted the quiz'),
          text: t('give everyone full credit')
        }
      };
    }
  }, {
    key: "scoreReconciliation",
    get: function get() {
      return this.props.scoreReconciliation;
    }
  }, {
    key: "selectHint",
    get: function get() {
      var hint = this.optionInputs[this.scoreReconciliation].hint;
      return [{
        text: t('Result: {hint}', {
          hint: hint
        }),
        type: 'hint'
      }];
    }
  }, {
    key: "cancelButton",
    value:
    // Rendering
    function cancelButton() {
      return jsx(Button, {
        margin: XSMALL_SIDE_MARGIN,
        onClick: this.cancelAction,
        ref: this.setRef('cancelImportButton')
      }, t('Cancel'));
    }
  }, {
    key: "regradeButton",
    value: function regradeButton() {
      return jsx(Button, {
        margin: XSMALL_SIDE_MARGIN,
        onClick: this.onSubmit,
        ref: this.setRef('confirmButton'),
        color: "primary",
        "data-automation": "sdk-regrade-button"
      }, t('Regrade'));
    }
  }, {
    key: "setRef",
    value: function setRef(refName) {
      var _this2 = this;
      return function (node) {
        _this2[refName] = node;
      };
    }
  }, {
    key: "renderOptionInputs",
    value: function renderOptionInputs() {
      return Object.entries(this.optionInputs).map(function (optionInput) {
        return jsx("option", {
          key: optionInput[0],
          value: optionInput[0]
        }, optionInput[1].text);
      });
    }
  }, {
    key: "renderRadioInputs",
    value: function renderRadioInputs() {
      return Object.entries(this.optionInputs).map(function (optionInput) {
        return jsx(RadioInput, {
          label: optionInput[1].text,
          value: optionInput[0],
          key: optionInput[0],
          "data-automation": "sdk-regrade-option-".concat(optionInput[0])
        });
      });
    }
  }, {
    key: "renderModalBody",
    value: function renderModalBody() {
      return jsx("div", null, jsx(Alert, {
        margin: "small 0",
        transition: "none",
        variant: "info"
      }, jsx("div", {
        css: this.props.styles.alert
      }, jsx("span", null, t.rich("\n                  <0>Regrading only applies to completed submissions.</0>\n                  <1>If all students are affected please wait for all submissions before Regrading.</1>\n                ", [function (_ref) {
        var children = _ref.children;
        return jsx(Text, {
          as: "div",
          weight: "bold",
          key: "0"
        }, children);
      }, function (_ref2) {
        var children = _ref2.children;
        return jsx(Text, {
          as: "span",
          key: "1"
        }, children);
      }])))), jsx("div", {
        css: this.props.styles.radioInputGroup,
        role: "form"
      }, jsx(RadioInputGroup, {
        description: t('Select how you would like to apply this regrade.'),
        name: "scoring_reconciliation",
        onChange: this.onSpeedgraderOptionChange,
        messages: this.selectHint,
        value: this.scoreReconciliation
      }, this.renderRadioInputs())));
    }
  }, {
    key: "renderErrorFromApi",
    value: function renderErrorFromApi() {
      if (this.state.hasGenericErrorFromApi) {
        return jsx("div", {
          css: this.props.styles.errorAlert
        }, jsx(InstUISettingsProvider, {
          theme: {
            componentOverrides: {
              Alert: {
                contentPadding: '0.4rem 1.5rem'
              }
            }
          }
        }, jsx(Alert, {
          margin: "0 0",
          transition: "fade",
          variant: "error"
        }, jsx(Text, {
          size: "small"
        }, t('Regrade did not run due to server error. Please try again later!')))));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Modal, {
        open: this.props.modalOpen,
        size: "medium",
        onDismiss: this.cancelAction,
        label: t('Question Regrade Options'),
        ref: this.setRef('modal'),
        "data-automation": "sdk-regrade-modal",
        shouldCloseOnDocumentClick: false
      }, jsx(ModalHeader, null, jsx(Heading, {
        level: "reset",
        as: "h2"
      }, t('Question Regrade Options')), jsx(CloseButton, {
        onClick: this.cancelAction,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), jsx(ModalBody, null, this.renderModalBody()), jsx(ModalFooter, null, this.renderErrorFromApi(), this.cancelButton(), this.regradeButton()));
    }
  }]);
}(Component), _defineProperty(_RegradingModal, "displayName", 'RegradingModal'), _defineProperty(_RegradingModal, "componentId", "Quizzes".concat(_RegradingModal.displayName)), _defineProperty(_RegradingModal, "propTypes", {
  addSuccess: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  createQuizEntryRegrade: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  quizId: PropTypes.string.isRequired,
  regradingPayload: PropTypes.shape({
    quizEntryId: PropTypes.string.isRequired,
    scoringAlgorithm: PropTypes.string,
    scoringData: PropTypes.object
  }).isRequired,
  scoreReconciliation: PropTypes.string.isRequired,
  setScoreReconciliation: PropTypes.func.isRequired,
  toggleRegradingEditMode: PropTypes.func.isRequired,
  handleValidationErrorsFromApi: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_RegradingModal, "defaultProps", {
  handleValidationErrorsFromApi: Function.prototype
}), _RegradingModal)) || _class);
export default RegradingModal;